import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { ReporteIndService } from '../services/reporte-ind.service';
import { RegistroService } from 'src/app/registro.service';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-modal-ventas',
    templateUrl: './modal-ventas.component.html',
    styleUrls: [
        './modal-ventas.component.css',
        '../../components/view-succes/view-succes.component.css',
    ],
})
export class ModalVentasComponent implements OnInit {
    displayIdl = false;
    mensaje =
        'Por favor seleccione el año y mes en el que va a diligenciar la información de ventas e inventarios de los productos';
    selectedYear: number;
    selectedMonth;
    years = [];
    months = [];
    errorMessages: string[] = [];
    ultimoObjetoCreado;
    ReporteExiste;
    displeyIdlConfirm = false;
    mensajeConfirm = 'confirmación';
    displeyIdl = false;
    nombreBtn = 'Volver';
    confirm = false;

    constructor(
        private readonly router: Router,
        private readonly reporteService: ReporteIndService,
        private readonly registroService: RegistroService
    ) {}

    ngOnInit() {
        const idReporteGuardado: any =
            this.registroService.listaReportesGuardados.find(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa ===
                    this.registroService.empresaSelected
            );
        this.ultimoObjetoCreado = idReporteGuardado;
        this.years = this.reporteService.obtenerFechasValidas();
    }

    /**
     * Actualiza los meses válidos cuando cambia el año seleccionado.
     *
     * @remarks
     * Obtiene los meses desde `reporteService` según el año elegido
     * y reinicia la selección del mes actual.
     */
    onYearChange(): void {
        const monthsValidos = this.reporteService.obtenerMesesValidos(
            this.selectedYear
        );
        this.months = monthsValidos;
        this.selectedMonth = null; // Reiniciar selección de mes
    }

    /**
     * Muestra el modal para seleccionar año y mes del reporte.
     */
    viewReport() {
        this.displayIdl = true;
    }

    /**
     * Cierra el modal de selección de fecha y limpia los mensajes de error.
     */
    closeReport() {
        this.displayIdl = false;
        this.errorMessages = [];
    }

    /**
     * Valida los datos seleccionados (año y mes) y decide si mostrar
     * un reporte existente o crear uno nuevo.
     */
    pageReport() {
        this.errorMessages = [];
        if (!this.selectedYear) {
            this.errorMessages.push('El año es requerido.');
        }
        if (!this.selectedMonth) {
            this.errorMessages.push('El mes es requerido.');
        }
        if (this.errorMessages.length === 0) {
            if (this.ultimoObjetoCreado) {
                this.mostrarReporte();
            } else {
                this.ReporteExist();
            }
        }
    }

    /**
     * Navega hacia la página de reporte de ventas, enviando los parámetros seleccionados.
     * Además, elimina el registro temporal de reportes guardados de la empresa actual.
     */
    private navigateWithParams() {
        const queryParams: NavigationExtras = {
            queryParams: {
                year: this.selectedYear,
                month: this.selectedMonth.name,
                monthNumber: this.selectedMonth.number,
            },
        };
        this.router.navigate(['reporte-ventas'], queryParams);
        this.displayIdl = false;
        const idEmpresaSeleccionada = this.registroService.empresaSelected;
        const indexReporteGuardado =
            this.registroService.listaReportesGuardados.findIndex(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa === idEmpresaSeleccionada
            );

        if (indexReporteGuardado !== -1) {
            const nuevosReportes =
                this.registroService.listaReportesGuardados.filter(
                    (agenteVigilado) =>
                        agenteVigilado.idEmpresa !== idEmpresaSeleccionada
                );
            this.registroService.listaReportesGuardados = nuevosReportes;
        }
    }

    /**
     * Regresa a la vista de carga y consulta de reportes,
     * cerrando el modal principal.
     */
    public volver() {
        this.router.navigate(['carga-consulta-reportes']);
        this.displeyIdl = false;
    }

    /**
     * Cierra el modal de confirmación y regresa a la vista principal de reportes.
     */
    volverConfirm() {
        this.router.navigate(['carga-consulta-reportes']);
        this.displeyIdlConfirm = false;
    }

    /**
     * Continúa con la navegación hacia el reporte,
     * cerrando ambos modales de confirmación y selección.
     */
    continuar() {
        this.navigateWithParams();
        this.displeyIdl = false;
        this.displeyIdlConfirm = false;
    }

    /**
     * Muestra una ventana de confirmación indicando
     * que existe un reporte pendiente y que la información se perderá.
     */
    mostrarReporte() {
        this.displeyIdlConfirm = true;
        this.mensajeConfirm =
            'Tienes un reporte pendiente, se perderán la información avanzada';
    }

    /**
     * Verifica si ya existe un reporte creado para la fecha seleccionada.
     *
     * @remarks
     * Si no existe un reporte previo, navega al formulario de creación.
     * Si existe, muestra una confirmación para reemplazar el existente.
     */
    async ReporteExist() {
        try {
            this.ReporteExiste = await this.reporteService.getReporteDate(
                this.selectedYear.toString(),
                this.selectedMonth.number.toString()
            );
            if (this.ReporteExiste.length === 0) {
                this.navigateWithParams();
                this.displeyIdlConfirm = false;
            } else {
                const validacion = await this.validarAntesDeContinuar();
                if (!validacion) {
                    this.displeyIdlConfirm = false;
                    this.displayIdl = false;
                    return;
                }

                this.mensajeConfirm =
                    'El reporte para esta fecha ya existe, ¿Seguro que quiere reemplazarlo?';
                this.displeyIdlConfirm = true;
            }
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * Valida si el reporte puede ser reemplazado consultando al servicio correspondiente.
     *
     * @returns {Promise<boolean>} `true` si puede reemplazarse, `false` en caso contrario o error.
     *
     * @example
     * const valido = await validarAntesDeContinuar();
     */
    async validarAntesDeContinuar(): Promise<boolean> {
        try {
            const result = await firstValueFrom(
                this.reporteService.validarReemplazo({
                    agenteVigiladoId: Number(
                        this.registroService.empresaSelected
                    ),
                    anio: Number(this.selectedYear),
                    periodo: Number(this.selectedMonth.number),
                })
            );
            return result;
        } catch (error: any) {
            await Swal.fire({
                icon: 'error',
                title: 'No es posible reemplazar el reporte',
                text:
                    error?.error?.message ||
                    'El reporte no puede ser reemplazado',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
            });
            return false;
        }
    }
}
